import { Dispatch } from 'react';

import { ApiTags } from 'src/services/api';
import { subscriptionsApi } from 'src/services/api/subscriptionsApi';

export function clientCompanySubscriptionHandler(dispatch: Dispatch<any>) {
  dispatch(subscriptionsApi.util.invalidateTags([ApiTags.clientSubscription]));
}
